/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desk_Sso_Error_UnexpectedInputs */

const vi_desk_sso_error_unexpected = /** @type {(inputs: Desk_Sso_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có lỗi khi tạo liên kết sang trang hỗ trợ. Vui lòng thử lại.`)
};

/**

* @param {Desk_Sso_Error_UnexpectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const desk_sso_error_unexpected = /** @type {((inputs?: Desk_Sso_Error_UnexpectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desk_Sso_Error_UnexpectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_desk_sso_error_unexpected(inputs)
});